export class Transittime {
    FromPortIds :string;

    ToPortIds :string;

    fromdate :string;

    todate :string;
    Transhipment:number;
}